import { initializeMessenger } from '@core/messengers'
import {
  processWalletAction,
  WalletActionArguments,
} from '@plug-core/handlers/walletActions/processWalletAction'

const popupMessenger = initializeMessenger({ connect: 'popup' })

const handleWalletAction = () =>
  popupMessenger.reply(
    'plug_wallet_action',
    async ({ action, payload, wallet }: WalletActionArguments) => {
      const response = await processWalletAction({ action, payload, wallet })

      return { result: response }
    }
  )

export default handleWalletAction
